import LoginPage, { getDefaultPageData } from "components/pages/LoginPage";
import { BCMSStateManagerCRUD } from "bcms-react";
import "./styles.css";

/**
 * @function CaptureChatLogIn
 * @return {React.Component}
 * @exported true
 * @description Capture component for "007_Chat_Log_In".
 */
export default function CaptureChatLogIn(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "userID" ], "GeorgeW")
        .update([ "password" ], "1234567890")
        .submit();

    return <div className="chat-log-in-007"><LoginPage data={ data } /></div>
}